// Disabled variants of social network icons
// These use the same source SVGs; greyscale styling is applied at the component level
import instagram_ from "root/utils/socialNetworks/icons/instagram.svg";
import vkontakte_ from "root/utils/socialNetworks/icons/vkontakte.svg";
import telegram_ from "root/utils/socialNetworks/icons/telegram.svg";
import tiktok_ from "root/utils/socialNetworks/icons/tiktok.svg";
import dzen_ from "root/utils/socialNetworks/icons/dzen.svg";
import youtube_ from "root/utils/socialNetworks/icons/youtube.svg";

export const dInstagram = instagram_;
export const dVkontakte = vkontakte_;
export const dTelegram = telegram_;
export const dTikTok = tiktok_;
export const dDzen = dzen_;
export const dYouTube = youtube_;

export default {
    dInstagram,
    dVkontakte,
    dTelegram,
    dTikTok,
    dDzen,
    dYouTube,
};
